import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import { login, logout, getUserInfo as _getUserInfo, getMessage, getContentByMsgId as _getContentByMsgId, hasRead as _hasRead, removeReaded as _removeReaded, restoreTrash as _restoreTrash, getUnreadCount, UpdPWD, UpdPWDWage, SetMotto, SetAvatar, register, Forgot, getregion, getsms, GetEmall, savebaseinfo, changeaccount, real_name_auth, enterprise, enterprise_audit_count_down, realname_audit_count_downr, index_overview, service_overview, user_overview, product_overview } from "@/api/user";
import { getdownloadtoken } from "@/api/jingxiaoshang";
import { setToken as _setToken, getToken } from "@/libs/util";
import config from "@/config/index";
import { JSEncrypt } from "jsencrypt";
import Cookies from "js-cookie";
export default {
  state: {
    userName: "",
    userId: "",
    avatorImgPath: "",
    token: getToken(),
    access: "",
    hasGetInfo: false,
    unreadCount: 0,
    messageUnreadList: [],
    messageReadedList: [],
    messageTrashList: [],
    messageContentStore: {},
    userInfo: {},
    oldState: false,
    //call status
    companyCode: null,
    websocketData: null
  },
  mutations: {
    setWebsocketData: function setWebsocketData(state, data) {
      state.websocketData = data;
    },
    setUersInfo: function setUersInfo(state, data) {
      state.userInfo = data;
    },
    setAvator: function setAvator(state, avatorPath) {
      state.avatorImgPath = avatorPath;
    },
    setUserId: function setUserId(state, id) {
      state.userId = id;
    },
    setUserName: function setUserName(state, name) {
      state.userName = name;
    },
    setAccess: function setAccess(state, access) {
      state.access = access;
    },
    setToken: function setToken(state, token) {
      state.token = token;

      _setToken(token);
    },
    setHasGetInfo: function setHasGetInfo(state, status) {
      state.hasGetInfo = status;
    },
    setMessageCount: function setMessageCount(state, count) {
      state.unreadCount = count;
    },
    setMessageUnreadList: function setMessageUnreadList(state, list) {
      state.messageUnreadList = list;
    },
    setMessageReadedList: function setMessageReadedList(state, list) {
      state.messageReadedList = list;
    },
    setMessageTrashList: function setMessageTrashList(state, list) {
      state.messageTrashList = list;
    },
    updateMessageContentStore: function updateMessageContentStore(state, _ref) {
      var msg_id = _ref.msg_id,
          content = _ref.content;
      state.messageContentStore[msg_id] = content;
    },
    moveMsg: function moveMsg(state, _ref2) {
      var from = _ref2.from,
          to = _ref2.to,
          msg_id = _ref2.msg_id;
      var index = state[from].findIndex(function (_) {
        return _.msg_id === msg_id;
      });
      var msgItem = state[from].splice(index, 1)[0];
      msgItem.loading = false;
      state[to].unshift(msgItem);
    },

    /**
     * 改变call status
     * @param state
     * @param flag
     */
    changeOlaState: function changeOlaState(state, flag) {
      state.oldState = flag;
    },
    setCompanyCode: function setCompanyCode(state, code) {
      state.companyCode = code;
    }
  },
  getters: {
    messageUnreadCount: function messageUnreadCount(state) {
      return state.messageUnreadList.length;
    },
    messageReadedCount: function messageReadedCount(state) {
      return state.messageReadedList.length;
    },
    messageTrashCount: function messageTrashCount(state) {
      return state.messageTrashList.length;
    }
  },
  actions: {
    // 登录
    handleLogin: function handleLogin(_ref3, params) {
      var commit = _ref3.commit;
      var param = {};
      param.admin_password = params.password;
      param.admin_name = params.userName;
      param.admin_lang_type = params.admin_lang_type;
      return new Promise(function (resolve, reject) {
        login(param).then(function (res) {
          if (res.result === 0) {
            commit("setToken", res.body.token);
          } else {
            commit("setToken", "");
          }

          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    // 退出登录
    handleLogOut: function handleLogOut(_ref4, params) {
      var state = _ref4.state,
          commit = _ref4.commit;
      return new Promise(function (resolve, reject) {
        // debugger
        logout(params).then(function (res) {
          //  debugger
          if (res.result === 0) {
            // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
            commit("setToken", "");
            commit("setAccess", []);
            commit("setUersInfo", {});
            commit("setHasGetInfo", false);
            Cookies.remove("token");
            Cookies.set("confirm_password", "0", 0); //Cookies.remove('confirm_password');

            localStorage.clear();
            sessionStorage.clear();
            resolve(res);
          } else {}
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    //注册商家账号
    handleRegister: function handleRegister(_ref5, params) {
      var commit = _ref5.commit;
      return new Promise(function (resolve, reject) {
        register(params).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    //找回密码
    handleForgot: function handleForgot(_ref6, params) {
      var commit = _ref6.commit;
      return new Promise(function (resolve, reject) {
        Forgot(params).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    //获取短信验证码
    handleGetsms: function handleGetsms(_ref7, params) {
      var commit = _ref7.commit;
      return new Promise(function (resolve, reject) {
        getsms(params).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    //获取邮箱验证码
    handleGetEmall: function handleGetEmall(_ref8, params) {
      var commit = _ref8.commit;
      return new Promise(function (resolve, reject) {
        GetEmall(params).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    //保存基本信息
    handleSavebaseinfo: function handleSavebaseinfo(_ref9, params) {
      var commit = _ref9.commit;
      return new Promise(function (resolve, reject) {
        savebaseinfo(params).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    //保存基本信息
    handlegetdownloadtoken: function handlegetdownloadtoken(_ref10, params) {
      var commit = _ref10.commit;
      return new Promise(function (resolve, reject) {
        getdownloadtoken(params).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    // 获取用户相关信息
    getUserInfo: function getUserInfo(_ref11) {
      var state = _ref11.state,
          commit = _ref11.commit;
      return new Promise(function (resolve, reject) {
        try {
          _getUserInfo().then(function (res) {
            if (res.result === 0) {
              var data = res.body;
              commit("setUersInfo", data);
              commit("setAvator", data.avatar);
              commit("setUserName", data.admin_name);
              commit("setHasGetInfo", true);
              commit("setCompanyCode", data.company_code);
              resolve(res);
            } else {
              resolve(false);
            }
          }).catch(function (err) {
            reject(err);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    /**
     * 获取地区省市县
     */
    handleGetregion: function handleGetregion(_ref12, params) {
      var commit = _ref12.commit;
      return new Promise(function (resolve, reject) {
        getregion(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    // 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
    getUnreadMessageCount: function getUnreadMessageCount(_ref13) {
      var state = _ref13.state,
          commit = _ref13.commit;
      getUnreadCount().then(function (res) {
        var data = res.data;
        commit("setMessageCount", data);
      });
    },
    // 获取消息列表，其中包含未读、已读、回收站三个列表
    getMessageList: function getMessageList(_ref14) {
      var state = _ref14.state,
          commit = _ref14.commit;
      return new Promise(function (resolve, reject) {
        getMessage().then(function (res) {
          var _res$data = res.data,
              unread = _res$data.unread,
              readed = _res$data.readed,
              trash = _res$data.trash;
          commit("setMessageUnreadList", unread.sort(function (a, b) {
            return new Date(b.create_time) - new Date(a.create_time);
          }));
          commit("setMessageReadedList", readed.map(function (_) {
            _.loading = false;
            return _;
          }).sort(function (a, b) {
            return new Date(b.create_time) - new Date(a.create_time);
          }));
          commit("setMessageTrashList", trash.map(function (_) {
            _.loading = false;
            return _;
          }).sort(function (a, b) {
            return new Date(b.create_time) - new Date(a.create_time);
          }));
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 根据当前点击的消息的id获取内容
    getContentByMsgId: function getContentByMsgId(_ref15, _ref16) {
      var state = _ref15.state,
          commit = _ref15.commit;
      var msg_id = _ref16.msg_id;
      return new Promise(function (resolve, reject) {
        var contentItem = state.messageContentStore[msg_id];

        if (contentItem) {
          resolve(contentItem);
        } else {
          _getContentByMsgId(msg_id).then(function (res) {
            var content = res.data;
            commit("updateMessageContentStore", {
              msg_id: msg_id,
              content: content
            });
            resolve(content);
          });
        }
      });
    },
    // 把一个未读消息标记为已读
    hasRead: function hasRead(_ref17, _ref18) {
      var state = _ref17.state,
          commit = _ref17.commit;
      var msg_id = _ref18.msg_id;
      return new Promise(function (resolve, reject) {
        _hasRead(msg_id).then(function () {
          commit("moveMsg", {
            from: "messageUnreadList",
            to: "messageReadedList",
            msg_id: msg_id
          });
          commit("setMessageCount", state.unreadCount - 1);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 删除一个已读消息到回收站
    removeReaded: function removeReaded(_ref19, _ref20) {
      var commit = _ref19.commit;
      var msg_id = _ref20.msg_id;
      return new Promise(function (resolve, reject) {
        _removeReaded(msg_id).then(function () {
          commit("moveMsg", {
            from: "messageReadedList",
            to: "messageTrashList",
            msg_id: msg_id
          });
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 还原一个已删除消息到已读消息
    restoreTrash: function restoreTrash(_ref21, _ref22) {
      var commit = _ref21.commit;
      var msg_id = _ref22.msg_id;
      return new Promise(function (resolve, reject) {
        _restoreTrash(msg_id).then(function () {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    /**
     * 检查客户号码是否属于当前账号
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleCustomerIsBelongMe: function handleCustomerIsBelongMe(_ref23, params) {
      var commit = _ref23.commit;
      return new Promise(function (resolve, reject) {
        CustomerIsBelongMe(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 添加客户基本信息
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleAddCustomer: function handleAddCustomer(_ref24, params) {
      var commit = _ref24.commit;
      return new Promise(function (resolve, reject) {
        AddCustomer(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 修改密码
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleUpdPWD: function handleUpdPWD(_ref25, params) {
      var commit = _ref25.commit;
      var key = config.jsencryptKey;
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(key);
      params.oldPwd = encrypt.encrypt(params.oldPwd);
      params.newPwd = encrypt.encrypt(params.newPwd);
      return new Promise(function (resolve, reject) {
        UpdPWD(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 修改查看工资密码
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleUpdPWDWage: function handleUpdPWDWage(_ref26, param) {
      var commit = _ref26.commit;
      var key = config.jsencryptKey;
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(key);
      var params = {};
      Object.assign(params, param);
      params.oldPayrollPwd = encrypt.encrypt(params.oldPayrollPwd);
      params.newPayrollPwd = encrypt.encrypt(params.newPayrollPwd);
      return new Promise(function (resolve, reject) {
        UpdPWDWage(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 设置登录人座右铭
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleSetMotto: function handleSetMotto(_ref27, params) {
      var commit = _ref27.commit;
      return new Promise(function (resolve, reject) {
        SetMotto(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 设置头像
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleSetAvatar: function handleSetAvatar(_ref28, params) {
      var commit = _ref28.commit;
      return new Promise(function (resolve, reject) {
        SetAvatar(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * getemailcode 变更账号
     */
    handleChangeaccount: function handleChangeaccount(_ref29, params) {
      var commit = _ref29.commit;
      return new Promise(function (resolve, reject) {
        changeaccount(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 19.实名认证 enterprise
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handlereal_name_auth: function handlereal_name_auth(_ref30, params) {
      var commit = _ref30.commit;
      return new Promise(function (resolve, reject) {
        real_name_auth(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * enterprise //20.企业认证
     */
    handleEnterprise: function handleEnterprise(_ref31, params) {
      var commit = _ref31.commit;
      return new Promise(function (resolve, reject) {
        enterprise(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 企业认证倒计时
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleenterprise_audit_count_down: function handleenterprise_audit_count_down(_ref32, params) {
      var commit = _ref32.commit;
      return new Promise(function (resolve, reject) {
        enterprise_audit_count_down(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 实名认证倒计时
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handlerealname_audit_count_downr: function handlerealname_audit_count_downr(_ref33, params) {
      var commit = _ref33.commit;
      return new Promise(function (resolve, reject) {
        realname_audit_count_downr(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 首页总览统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleindex_overview: function handleindex_overview(_ref34, params) {
      var commit = _ref34.commit;
      return new Promise(function (resolve, reject) {
        index_overview(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 产品统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleproduct_overview: function handleproduct_overview(_ref35, params) {
      var commit = _ref35.commit;
      return new Promise(function (resolve, reject) {
        product_overview(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 用户统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleuser_overview: function handleuser_overview(_ref36, params) {
      var commit = _ref36.commit;
      return new Promise(function (resolve, reject) {
        user_overview(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * 服务统计数据
     * @param commit
     * @param params
     * @returns {Promise<any>}
     */
    handleservice_overview: function handleservice_overview(_ref37, params) {
      var commit = _ref37.commit;
      return new Promise(function (resolve, reject) {
        service_overview(params).then(function (res) {
          if (res.result === 0) {
            resolve(res);
          } else {
            resolve(res);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }
};